import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Gdpr() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page">
      <div className="aurora-wrap" aria-hidden="true">
        <div className="orb orb-1" />
        <div className="orb orb-2" />
      </div>
      <div className="legal-inner container">
        <Link to="/" className="legal-back">← Späť na hlavnú stránku</Link>
        <h1 className="legal-title">Ochrana osobných údajov</h1>
        <p className="legal-updated">Posledná aktualizácia: 1. januára 2026</p>

        <div className="legal-content">
          <h2>1. Správca osobných údajov</h2>
          <p>
            Správcom osobných údajov je Kamil Frajtko – Boostio, so sídlom v Slovenskej republike.
            Kontakt: <a href="mailto:info@boostio.sk">info@boostio.sk</a>
          </p>

          <h2>2. Aké údaje zbierame</h2>
          <p>V rámci poskytovania našich služieb môžeme spracovávať nasledujúce osobné údaje:</p>
          <ul>
            <li>Meno a priezvisko</li>
            <li>E-mailová adresa</li>
            <li>Telefónne číslo (ak je poskytnuté)</li>
            <li>URL adresa webstránky</li>
            <li>Správa/dopyt odoslaný prostredníctvom kontaktného formulára</li>
          </ul>

          <h2>3. Účel spracovania</h2>
          <p>Vaše osobné údaje spracovávame výhradne za účelom:</p>
          <ul>
            <li>Odpovede na vaše dopyty a poskytnutia bezplatnej analýzy webu</li>
            <li>Uzatvorenia a plnenia zmluvy o poskytovaní služieb</li>
            <li>Zasielania obchodných ponúk (len so súhlasom)</li>
            <li>Analýzy návštevnosti webu (Google Analytics 4 – anonymizované dáta)</li>
          </ul>

          <h2>4. Právny základ</h2>
          <p>
            Spracovanie osobných údajov je založené na čl. 6 ods. 1 písm. b) GDPR (plnenie zmluvy),
            čl. 6 ods. 1 písm. f) GDPR (oprávnený záujem) a čl. 6 ods. 1 písm. a) GDPR (súhlas),
            podľa konkrétneho účelu spracovania.
          </p>

          <h2>5. Doba uchovávania</h2>
          <p>
            Osobné údaje uchovávame po dobu nevyhnutnú na splnenie účelu spracovania, najdlhšie
            3 roky od poslednej interakcie, ak zákon nevyžaduje dlhšiu dobu.
          </p>

          <h2>6. Vaše práva</h2>
          <p>V súvislosti s ochranou osobných údajov máte právo:</p>
          <ul>
            <li>Na prístup k svojim osobným údajom</li>
            <li>Na opravu nesprávnych údajov</li>
            <li>Na vymazanie údajov ("právo byť zabudnutý")</li>
            <li>Na obmedzenie spracovania</li>
            <li>Na prenosnosť údajov</li>
            <li>Namietať spracovanie</li>
            <li>Odvolať súhlas kedykoľvek</li>
          </ul>
          <p>
            Tieto práva môžete uplatniť na adrese: <a href="mailto:info@boostio.sk">info@boostio.sk</a>
          </p>

          <h2>7. Cookies</h2>
          <p>
            Naša stránka používa cookies na zlepšenie užívateľského zážitku a analýzu návštevnosti.
            Nevyhnutné cookies sú aktívne vždy. Analytické cookies (Google Analytics) aktivujeme
            len s vaším súhlasom.
          </p>

          <h2>8. Dozorný orgán</h2>
          <p>
            Ak sa domnievate, že spracovanie vašich osobných údajov porušuje predpisy GDPR, máte
            právo podať sťažnosť na Úrad na ochranu osobných údajov SR (uoou.sk).
          </p>
        </div>
      </div>
    </div>
  );
}
